export const ComplianceUploadAcceptedExtensions = [
  'csv',
  'pdf',
  'xlsx',
] as const;

export const MarketingUploadAcceptedExtensions = [
  'aep',
  'ai',
  'avif',
  'csv',
  'docx',
  'ds_store',
  'gif',
  'jpeg',
  'jpg',
  'key',
  'mov',
  'mp3',
  'mp4',
  'otf',
  'pdf',
  'png',
  'pptx',
  'psb',
  'psd',
  'spine',
  'svg',
  'swf',
  'txt',
  'unknown',
  'wav',
  'webp',
  'xlsx',
  'zip',
] as const;
